import instance from '@/api/business'
import { Cockpit, PropsCockpit, PropsDetailNF, PropsInformSequenceDocument, PropsInformImpediment, informOperationHubProps, informOperationInNFProps } from './type' 
import { Details } from '@/types/DetailNF' 

export const fetchCockpit = async ({initialDate, finalDate, doc}: PropsCockpit) => {
    const response = await instance.post<Cockpit[]>('/cockpit/cockpit/operationinprogress',
        {
            initialDate, 
            finalDate,
            doc
        }
    ) 
    return response.data
} 

export const fetchDetailNF = async ({SK_NF} : PropsDetailNF) => {
    const response = await instance.post<Details>('/cockpit/cockpit/detailnf', {SK_NF})

    return response.data
}

export const fetchInformSequenceDocument = async ({SK_NF, DD_DOC_SEQUENCIA, DD_SERIE_SEQUENCIA } : PropsInformSequenceDocument) => {
    const response = await instance.patch('/cockpit/cockpit/informsequencedocument', {
        SK_NF, 
        DD_DOC_SEQUENCIA, 
        DD_SERIE_SEQUENCIA
    })

    return response.data
}
  
export const fetchInformImpediment = async ({SK_NF, SK_IMPEDITIVO} : PropsInformImpediment) => {
    const response = await instance.patch('/cockpit/cockpit/informimpediment', {
        SK_NF,
        SK_IMPEDITIVO
    })

    return response.data
}
 
export const informOperationHub = async ({SK_NF , DD_PROCESSO_HUB}: informOperationHubProps) => {
    const response = await instance.patch('/cockpit/cockpit/operationhub', {
        SK_NF,
        DD_PROCESSO_HUB
    })

    return response.data 
}

export const informOperationInNF = async ({SK_NF , SK_CABECALHO_OPERACAO}: informOperationInNFProps) => {
    const response = await instance.patch('/cockpit/cockpit/informoperationinnf', {
        SK_NF,
        SK_CABECALHO_OPERACAO
    })

    return response.data 
}